module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12AZMWQ/images/cover.jpg?1684514755297",
      "alt": "This image is the cover for the book Rule of Thumb: A Guide to Sustainability for Small Business, Rule of Thumb"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rule of Thumb: A Guide to Sustainability for Small Business, Rule of Thumb\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Real world and commonly understood examples and experiences help the reader identify strengths which underscore a healthy marketing business plan and mistakes to avoid. Rules of Thumb throughout create easy to remember and apply fundamental principles and guideposts along the marketing journey.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Beverly Browning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dr. Beverly A. Browning (Dr. Bev) has been consulting in the areas of grant writing, contract bid responses, and organizational development for nearly four decades. She has assisted municipal clients and workshop participants throughout the United States in receiving grant awards of more than $350 million. Dr. Bev is the author of 40 grants-related publications, including Grant Writing For Dummies, Grant Writing for Educators, How to Become a Grant Writing Consultant, Faith-Based Grants: Aligning Your Church to Receive Abundance, Perfect Phrases for Writing Grant Proposals, Rule of Thumb: A Guide to Small Business Sustainability (WriteLife, 2012), and Perfect Phrases for Fundraising (2012). She is an online expert-level instructor for ed2go.com and udemy.com. Dr. Browning is a current member of the Grant Professionals Association. She is the Vice President for Grants Professional Services at eCivis Inc.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BQB Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0